import { Component, Input } from '@angular/core';
import { ApiConnector, Table } from '@cureskin/api-client';
import { ConnectionService } from '../../../../services/connection-service';
import { HelperService } from '../../../../services/helper-service';
import { TimeService } from '../../../../services/time-service';
import { WindowRefService } from '../../../../services/window-ref-service';
import { AppConfig } from '../../../app.config';
import { Broadcaster } from '../../../../components/broadcaster';

@Component({
    selector: 'call-logs', templateUrl: './call-logs.html', styleUrls: ['./call-logs.scss'],
    standalone: false
})
export class CallLogsComponent {
  @Input('user')
  set userFunction(user: any) {
    this.user = user;
    if (!this.user || !this.user.id) {
      this.callLogs = [];
      return;
    }
    this.fetchUserCallLogs();
  }
  user: any;
  callLogs: Array<any> = [];

  constructor(public appConfig: AppConfig,
    private conn: ConnectionService,
    private time: TimeService,
    private window: WindowRefService,
    private broadcasterService: Broadcaster,
    public helper: HelperService) {
  }

  async ngOnInit(): Promise<any> {
  }

  async fetchUserCallLogs(): Promise<any> {
    const callLogs = await ApiConnector.find(Table.CallLog, {
      where: { user: this.user },
      descending: 'createdAt',
      include: ['internalUser'],
      project: ['direction', 'to', 'from', 'status', 'calledAt', 'conversationDuration', 'internalUser.username' as 'internalUser', 'internalUser.DoctorDisplayName' as 'internalUser'],
    });
    this.callLogs = callLogs;
  }

  callUserThroughExotel(number: any): void {
    this.conn.connectCallToUser(number, 'chatPage')
      .then(() => this.broadcasterService.broadcast('NOTIFY', { message: 'Connecting',
        type: this.appConfig.Shared.Toast.Type.SUCCESS }))
      .catch((error: any) => this.broadcasterService.broadcast('NOTIFY', { message: error.message,
        type: this.appConfig.Shared.Toast.Type.ERROR }));
  }
}
